module.exports = __webpack_public_path__ + "static/media/clients.9e5e96e9.png";